import { VisuallyHidden } from '../VisuallyHidden';

/**
 * Visually hidden input element, but still accessible for screen readers.
 */
export const VisuallyHiddenInput = VisuallyHidden.withComponent('input');
